import * as request from '@/utils/request'

export default {
  /**
   * @description 获取列表
   * @param {*} data
   * @returns
   */
  getFeiShuEventList(data) {
    return request.post('/feishu_talk_event/list', data)
  },
  /**
   * @description 获取信息
   * @param id
   * @returns {Promise}
   */
  getFeiShuEventInfo(id) {
    return request.post('/feishu_talk_event/get_info', { id: id })
  },
  /**
   * 删除
   * @param id
   * @returns {Promise}
   */
  delFeiShuEventInfo(id) {
    return request.post('/feishu_talk_event/delete', { id: id })
  },
  /**
   * 下拉框数据
   * @returns {Promise}
   */
  getFeiShuEventOptionMap() {
    return request.post('/feishu_talk_event/option_map', {})
  }
}
